<template>
    <div>
        <app-data-table
            :items="tableData.data"
            :fields="headers"
            @sort="onSort"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :from="tableData.from"
            :to="tableData.to"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="days" slot-scope="{ item }">
                <b-badge
                    variant="primary"
                    v-for="day in item.days"
                    :key="day.id"
                    >{{ getDay(day.day) }}</b-badge
                >
            </template>

            <template slot="controlPoints" slot-scope="{ item }">
                <b-badge variant="primary">{{
                    item.control_points.length
                }}</b-badge>
            </template>

            <template slot="checkList" slot-scope="{ item }">
                <b-badge variant="primary">{{
                    item.check_list.length
                }}</b-badge>
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-btn
                    size="sm"
                    @click="controlPointsConfig(item)"
                    variant="primary"
                >
                    <i class="fa fa-map-marker"></i>
                </b-btn>
                <b-btn
                    size="sm"
                    @click="checkListConfig(item)"
                    variant="primary"
                    ><i class="fa fa-list-ol"></i
                ></b-btn>
                <b-btn
                    size="sm"
                    variant="primary"
                    @click="openPrintPage(item.id)"
                    ><i class="fa fa-print"></i
                ></b-btn>
                <b-btn size="sm" variant="primary" @click="$emit('edit', item)"
                    ><i class="fa fa-pencil"></i
                ></b-btn>
                <b-btn size="sm" variant="danger" @click="onDeleteRound(item)"
                    ><i class="fa fa-trash"></i
                ></b-btn>
            </template>
        </app-data-table>
        <app-pop-up
            id="control-points-config-window"
            title="Configuración puntos de control"
            size="large"
        >
            <template slot="body">
                <b-container fluid>
                    <b-row>
                        <b-col cols="12">
                            <app-round-control-point-form
                                v-if="!!selectedRound"
                                :round="selectedRound"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <app-round-control-points-list
                                v-if="selectedRound"
                                :controlPoints="selectedRound.control_points"
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </template>
            <template slot="buttons"> </template>
        </app-pop-up>
        <app-pop-up
            id="checklist-config-window"
            size="large"
            title="Configuración de lista de chequeo"
        >
            <template slot="body">
                <b-row>
                    <b-col>
                        <app-round-checklist-form
                            v-if="!!selectedRound"
                            :round="selectedRound"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-round-checklist-items
                            v-if="!!selectedRound"
                            :items="selectedRound.check_list"
                        />
                    </b-col>
                </b-row>
            </template>
        </app-pop-up>
        <b-modal
            ref="round-delete-modal"
            id="round-delete-modal"
            title="¿Eliminar Ronda?"
            @ok="deleteRound"
        >
            <p>¿Esta seguro de eliminar la ronda?</p>
        </b-modal>
    </div>
</template>
<script>
import headers from './headers'
import RoundControlPointForm from './RoundControlPointForm/RoundControlPointForm'
import RoundControlPointsList from './RoundControlPointsList/RoundControlPointsList'
import RoundChecklistForm from './RoundChecklistForm/RoundChecklistForm'
import RoundChecklistItems from './RoundChecklistItems/RoundChecklistItems'

export default {
    components: {
        appRoundControlPointForm: RoundControlPointForm,
        appRoundControlPointsList: RoundControlPointsList,
        appRoundChecklistForm: RoundChecklistForm,
        appRoundChecklistItems: RoundChecklistItems,
    },
    props: {
        tableData: {
            type: Object,
            default: [],
        },
    },
    data: () => ({
        headers,
        selectedRound: '',
    }),
    methods: {
        getDay(day) {
            const days = {
                0: 'Dom',
                1: 'Lun',
                2: 'Mar',
                3: 'Mie',
                4: 'Jue',
                5: 'Vie',
                6: 'Sab',
            }

            return days[day]
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        onChangePage(page) {
            this.$emit('changePage', page)
        },
        controlPointsConfig(item) {
            this.selectedRound = item
            this.$bus.$emit('control-points-config-window.open')
        },
        checkListConfig(item) {
            this.selectedRound = item
            this.$bus.$emit('checklist-config-window.open')
        },
        onDeleteRound(item) {
            this.selectedRound = item
            this.$refs['round-delete-modal'].show()
        },
        deleteRound() {
            const round = this.selectedRound
            this.$emit('delete', round)
            this.selectedRound = ''
        },
        openPrintPage(roundId) {
            var win = window.open(
                `/rounds/print-control-points?round=${roundId}`,
                '_blank'
            )
            win.focus()
        },
    },
}
</script>
